import React from 'react';
import { List } from 'react-content-loader'
import { useHistory, withRouter } from 'react-router-dom';
import { Button, Grid, Icon, Page } from 'tabler-react';
import PrivatePage from './PrivatePage';
import { Backend } from '../services';

function ProjectIndexPage(props) {
  const history = useHistory();
  const [loading, setLoading] = React.useState(true);
  const [groups, setGroups] = React.useState(null);

  React.useEffect(() => {
    fetchRows();
  }, []);

  const fetchRows = async () => {
    try {
      setGroups(null);

      const res = await Backend.listProjects();
      const newGroups = res.data.rows.reduce((obj, row) => {
        if (!obj[row.group]) obj[row.group] = { group: row.group, projects: [] };
        
        obj[row.group].projects.push(row);

        return obj;
      }, {});

      setGroups(Object.keys(newGroups).map(k => newGroups[k]));
      setLoading(false);
    } catch(err) {
      console.error(err);
      alert('Something went wrong');
    }
  }

  const renderCard = (item) => (
    <div className="card">
      <a href="#">
        <div style={{
          width: '100%',
          height: '152px',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundImage: `url('${Backend.generateProjectImageUrl(item.id, item.images.find(i => i.kind === 'banner')?.id)}')`}}>
        </div>
      </a>
    
      <div className="d-flex justify-content-between p-3">
        <div>
          <div className="label-color" style={{fontWeight: 600}}>{item.name}</div>
          <small className="d-block text-muted">
          {
            item.kind === 'residential' ? 'Residencial' : (
              item.kind === 'business' ? 'Empresarial' : (
                item.kind === 'area' ? 'Área': (
                  item.kind === 'mixed' ? 'Misto': ''
                )
              )
            )
          }
          </small>
        </div>
        <div className="text-muted text-right d-flex flex-column">
          {
            item.accredited ?
            <>
              <Icon name="unlock"/>
              <Button link className="px-0" onClick={() => history.push(`/projects/${item.id}`)}>Ver Lotes</Button>
            </>
            :
            <>
              <Icon name="lock"/>
              <Button link className="px-0" onClick={() => history.push(`/projects/${item.id}/accreditation`)}>Credenciar</Button>
            </>
          }
        </div>
      </div>
    </div>
  )

  const renderGroups = (groups) => (
    <>
      {
        groups.map(group => (
          <div key={group.group}>
            <h2>{group.group}</h2>
            <Grid.Row className="row-cards">
            {   
              group.projects.map(project => (
                <Grid.Col sm={12} md={6} lg={4} key={project.id}>
                  { renderCard(project) }
                </Grid.Col>
              ))
            }
            </Grid.Row>
          </div>
        ))
      }
    </>
  );

  return (
    <PrivatePage>
      {
        loading ? <Page.Content><List foregroundColor="#DDD"/></Page.Content>
        :
        <Page.Content>
          <Page.Header title='Empreendimentos'/>
          { renderGroups(groups) }
        </Page.Content>
      }
    </PrivatePage>
  )
}

export default withRouter(ProjectIndexPage);